<section class="row mb-4 pl-2 border-left" *ngIf="arrayDocumentoAnterior.length == 0 && arrayCampoAdicionalAnterior.length == 0 || authService.getTipoUser() === tipo_prestador; else comparativo">
  <!-- V2 Campo Adicional -->
  <section class="col-sm-12 col-md-6 mb-4 mt-4">
    <div class="card">
      <h5 class="card-header">Campos adicionales</h5>
      <div class="card-body">
        <div class="row" *ngIf="arrayCampoAdicional != null && arrayCampoAdicional.length > 0 ; else sindatos_campos">
          <!-- Respuestas Generales -->
          <ul class="list-unstyled">
            <li class="mb-4" *ngFor="let item of arrayCampoAdicional">
              <!-- BIT -->
              <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Booleano">
                <span>{{item.titulo}}</span><br>
                <strong *ngIf="item.respuesta === '1' && !item.turismoAventura">Si</strong>
                <strong *ngIf="item.respuesta === '0' && !item.turismoAventura">No</strong>
                <!-- Turismo aventura -->
                <ng-container *ngIf="item.turismoAventura">
                  <ul>
                    <li *ngFor="let itemAventura of item.turismoAventura">{{itemAventura.descripcion}}</li>
                  </ul>
                </ng-container>
                <!-- Vehiculos-->
                <div *ngIf="item.vehiculos;">
                  <div class="col-sm-12 col-md-12 mt-1" *ngIf="item.vehiculos">
                    <h2 class="h6 mt-2 mb-2">Vehículos registrados</h2>
                    <ul class="list-group">
                      <app-tablas [headers]="headersVehiculos" class="table-responsive overflow" [paginar]="false">
                        <tr *ngFor="let item of item.vehiculos" class="small">
                          <td>{{item.marca}}</td>
                          <td>{{item.linea}}</td>
                          <td>{{item.placa}}</td>
                          <td>{{item.color}}</td>
                        </tr>
                      </app-tablas>
                    </ul>
                  </div>

                  <ng-template *ngIf="item.vehiculos.length === 0">
                    <span style="font-style: italic; margin-left: 10px; font-weight: bold">No se encontraron vehículos relacionados.</span>
                  </ng-template>
                </div>
              </div>
              <!-- BIGINT, VARCHAR -->
              <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Texto || item.desc_tipo_dato === TipoCampoAdicional.Numerico">
                <span>{{item.titulo}}</span><br>
                <strong>{{item.respuesta}}</strong>
              </div>
              <!-- TEXT_AREA -->
              <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.TextArea">
                <span>{{item.titulo}}</span><br>
                <strong>{{item.respuesta}}</strong>
              </div>
              <!-- DATETIME -->
              <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Fecha">
                <span>{{item.titulo}}</span><br>
                <strong>{{item.respuesta }}</strong>
              </div>
              <!-- MULTIPLE_CARACTERISTICA -->
              <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                <span>{{item.titulo}}</span><br>
                <div *ngFor="let caracteristica of item.multipleCaracterisitca">
                  <ng-container *ngIf="caracteristica.caracteristicas_opciones_descripcion !== 'Lista desplegable'">
                    <span class="pl-2">{{caracteristica.descripcion}}</span><br>
                    <strong class="pl-2">
                      {{caracteristica.Valor_Registros}}
                    </strong>
                  </ng-container>
                </div>
              </div>
              <!-- VARIOS_REGISTROS -->
              <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                <span>{{item.titulo}}</span><br>
                <span class="pl-2">{{item.titulo_varios_registros}}</span><br>
                <strong class="pl-2 text-break" >{{item.respuesta}}</strong>
              </div>
              <!-- MULTIPLE -->
              <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Multiple">
                <div>
                  <ul class="list-unstyled">
                    <li *ngFor="let hija of item.hijasMultiple; index as i">
                      <div [ngClass]=" i > 0 ? 'pl-2' : ''">
                        <!-- Respuestas multiple -->
                        <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Multiple">
                          <span>{{hija.titulo}}</span><br>
                          <strong>{{hija.respuesta}}</strong>
                        </ng-container>
                        <!-- Respuestas multiple caracteristica -->
                        <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                          <div *ngFor="let caracteristica of hija.caracteristicas_Opciones">
                            <span>{{caracteristica.descripcion}}</span><br>
                            <strong>{{caracteristica.Valor_Registros}}</strong>
                          </div>
                        </ng-container>
                        <!-- Respuestas Bit -->
                        <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Booleano">
                          <span>{{hija.titulo}}</span><br>
                          <strong *ngIf="hija.respuesta === '1'">Si</strong>
                          <strong *ngIf="hija.respuesta === '0'">No</strong>
                        </ng-container>
                        <!-- Respuestas varchar, date, numeric -->
                        <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Texto ||
                        hija.desc_tipo_dato === TipoCampoAdicional.Numerico ||
                        hija.desc_tipo_dato === TipoCampoAdicional.Fecha ||
                        hija.desc_tipo_dato === TipoCampoAdicional.TextArea">
                          <span>{{hija.titulo}}</span><br>
                          <strong>{{hija.respuesta}}</strong>
                        </ng-container>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- No data found -->
        <ng-template #sindatos_campos>
          <p class="small">Sin informacion registrada</p>
        </ng-template>
      </div>
    </div>
  </section>

  <!-- V2 Documentos -->
  <section class="col-sm-12 col-md-6 mb-4 mt-4">
    <div class="card">
      <h5 class="card-header">Cumplimiento de requisitos</h5>
      <div class="card-body">
        <div *ngIf="arrayDocumento!= null && arrayDocumento.length > 0 ; else sindatos_camposDoc">
          <app-tablas [headers]="headersDocumentos" class="table-responsive overflow" [paginar]="false">
            <tr *ngFor="let item of arrayDocumento">

              <!-- MULTIPLE -->
              <ng-container *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Multiple; else containerUnica">
                <td colspan="2">
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Multiple">
                    <div>
                      <ul class="list-unstyled">
                        <li *ngFor="let hija of item.hijasMultiple; index as i">
                          <!-- Sin son respuestas multiple -->
                          <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Multiple">
                            <div [ngClass]="{'pl-2' : i > 0}">
                              <span>{{hija.titulo}}</span><br>
                            </div>
                            <strong [ngClass]="{'pl-2' : i > 0}">{{hija.respuesta}}</strong>
                          </ng-container>
                          <!-- Sin son respuestas multiple caracteristica -->
                          <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                            <div *ngFor="let caracteristica of hija.caracteristicas_Opciones">
                              <div class="w-100">
                                <span [ngClass]="{'pl-2' : i > 0}">{{caracteristica.descripcion}}</span><br>
                              </div>
                              <strong [ngClass]="{'pl-2' : i > 0}">{{caracteristica.Valor_Registros}}</strong>
                            </div>
                          </ng-container>
                          <!-- Sin son respuestas Boolean -->
                          <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Booleano">
                            <span [ngClass]="{'pl-2' : i > 0}">{{hija.titulo}}</span><br>
                            <strong [ngClass]="{'pl-2' : i > 0}" *ngIf="hija.respuesta === '1'">Si</strong>
                            <strong [ngClass]="{'pl-2' : i > 0}" *ngIf="hija.respuesta === '0'">No</strong>
                          </ng-container>
                          <!-- Sin son respuestas Varios registros -->
                          <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                            <span [ngClass]="{'pl-2' : i > 0}">{{hija.titulo}}</span><br>
                            <strong [ngClass]="{'pl-2' : i > 0}">{{hija.respuesta}}</strong>
                          </ng-container>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
                <td>
                  {{item.numero_certificado}}
                </td>
              </ng-container>

              <ng-template #containerUnica>
                <td><span>{{item.titulo}}</span></td>
                <td>
                  <!-- BIT -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Booleano">
                    <strong *ngIf="item.respuesta === '1'">Si</strong>
                    <strong *ngIf="item.respuesta === '0'">No</strong>
                  </div>
                  <!-- BIGINT, VARCHAR -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Texto || item.desc_tipo_dato === TipoCampoAdicional.Numerico">
                    <strong>{{item.respuesta}}</strong>
                  </div>
                  <!-- TEXT_AREA -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.TextArea">
                    <strong>{{item.respuesta}}</strong>
                  </div>
                  <!-- DATETIME -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Fecha">
                    <strong>{{item.respuesta}}</strong>
                  </div>
                  <!-- MULTIPLE_CARACTERISTICA -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                    <div *ngFor="let caracteristica of item.multipleCaracterisitca">
                      <ng-container *ngIf="caracteristica.caracteristicas_opciones_descripcion !== 'Lista desplegable'">
                        <span class="pl-2">{{caracteristica.descripcion}}</span><br>
                        <strong class="pl-2">
                          {{caracteristica.Valor_Registros }}
                        </strong>
                      </ng-container>
                    </div>
                  </div>
                  <!-- VARIOS_REGISTROS -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                    <span class="pl-2">{{item.titulo_varios_registros}}</span><br>
                    <strong class="pl-2 text-break">{{item.respuesta}}</strong>
                  </div>
                </td>
                <td>
                  {{item.numero_certificado}}
                </td>
              </ng-template>
            </tr>
          </app-tablas>
        </div>

        <!-- No data found -->
        <ng-template #sindatos_camposDoc>
          <p class="small">Sin informacion registrada</p>
        </ng-template>
      </div>
    </div>
  </section>
</section>

<!-- COMPARATIVO -->
<ng-template #comparativo>
  <section class="row mb-4 pl-2 border-left">
    <!-- Version Actual -->
    <section class="col-sm-12 col-md-6 mb-4 mt-4 border-right">
      <h2 class="col-12 h5 font-weight-bold mb-2 border-actual">Versión actual</h2>

      <!-- Campo Adicional -->
      <div class="card mt-4">
        <h5 class="card-header">Campos adicionales</h5>

        <div class="card-body">
          <div class="row" *ngIf="arrayCampoAdicional!= null && arrayCampoAdicional.length > 0 ; else sindatos_camposVA">
            <ul class="list-unstyled">
              <li class="mb-2" *ngFor="let item of arrayCampoAdicional">
                <!-- BIT -->
                <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Booleano">
                  <span>{{item.titulo}}</span><br>
                  
                  <strong *ngIf="item.respuesta === '1' && !item.turismoAventura" [class]="item.backgroundColor">Si</strong>
                  <strong *ngIf="item.respuesta === '0' && !item.turismoAventura" [class]="item.backgroundColor">No</strong>

                  <strong *ngIf="item.turismoAventura?.length > 0 && item.turismoAventura" [class]="item.backgroundColor">Si</strong>
                  <strong *ngIf="item.turismoAventura?.length <= 0 && item.turismoAventura" [class]="item.backgroundColor">No</strong>
                  <!-- Turismo aventura -->
                  <ng-container *ngIf="item.turismoAventura">
                    <ul>
                      <li *ngFor="let itemAventura of item.turismoAventura" [class]="itemAventura.backgroundColor">
                        {{itemAventura.descripcion}}
                      </li>
                    </ul>
                  </ng-container>
                  <!-- Vehiculos-->
                  <div *ngIf="item.vehiculos;">
                    <div class="col-sm-12 col-md-12 mt-1" *ngIf="item.vehiculos">
                      <h2 class="h6 mt-2 mb-2">Vehículos registrados</h2>
                      <ul class="list-group">
                        <app-tablas [headers]="headersVehiculos" class="table-responsive overflow" [paginar]="false">
                          <tr *ngFor="let item of item.vehiculos" class="small">
                            <td>{{item.marca}}</td>
                            <td>{{item.linea}}</td>
                            <td>{{item.placa}}</td>
                            <td>{{item.color}}</td>
                          </tr>
                        </app-tablas>
                      </ul>
                    </div>

                    <ng-template *ngIf="item.vehiculos.length === 0">
                      <span style="font-style: italic; margin-left: 10px; font-weight: bold">No se encontraron vehículos relacionados.</span>
                    </ng-template>
                  </div>
                </div>
                <!-- BIGINT, VARCHAR -->
                <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Texto || item.desc_tipo_dato === TipoCampoAdicional.Numerico">
                  <span>{{item.titulo}}</span><br>
                  <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                </div>
                <!-- TEXT_AREA -->
                <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.TextArea">
                  <span>{{item.titulo}}</span><br>
                  <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                </div>
                <!-- DATETIME -->
                <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Fecha">
                  <span>{{item.titulo}}</span><br>
                  <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                </div>
                <!-- MULTIPLE_CARACTERISTICA -->
                <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                  <span>{{item.titulo}}</span><br>
                  <div *ngFor="let caracteristica of item.multipleCaracterisitca">
                    <ng-container *ngIf="caracteristica.caracteristicas_opciones_descripcion !== 'Lista desplegable'">
                      <span class="pl-2">{{caracteristica.descripcion}}</span><br>
                      <strong class="pl-2" [class]="caracteristica.backgroundColor">
                        {{caracteristica.Valor_Registros}}
                      </strong>
                    </ng-container>
                  </div>
                </div>
                <!-- VARIOS_REGISTROS -->
                <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                  <span>{{item.titulo}}</span><br>
                  <span class="pl-2">{{item.titulo_varios_registros}}</span><br>
                  <strong class="pl-2 text-break" [class]="item.backgroundColor">{{item.respuesta}}</strong>
                </div>
                <!-- MULTIPLE -->
                <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Multiple">
                  <div>
                    <ul class="list-unstyled">
                      <li *ngFor="let hija of item.hijasMultiple; index as i">
                        <div [ngClass]=" i > 0 ? 'pl-2' : ''">
                          <!-- Respuestas multiple -->
                          <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Multiple">
                            <span>{{hija.titulo}}</span><br>
                            <strong [class]="hija.backgroundColor">{{hija.respuesta}}</strong>
                          </ng-container>
                          <!-- Respuestas multiple caracteristica -->
                          <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                            <div *ngFor="let caracteristica of hija.caracteristicas_Opciones">
                              <span>{{caracteristica.descripcion}}</span><br>
                              <strong [class]="caracteristica.backgroundColor">{{caracteristica.Valor_Registros}}</strong>
                            </div>
                          </ng-container>
                          <!-- Respuestas Bit -->
                          <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Booleano">
                            <span>{{hija.titulo}}</span><br>
                            <strong *ngIf="hija.respuesta === '1'" [class]="hija.backgroundColor">Si</strong>
                            <strong *ngIf="hija.respuesta === '0'" [class]="hija.backgroundColor">No</strong>
                          </ng-container>
                          <!-- Respuestas Varios registros -->
                          <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                            <span>{{hija.titulo}}</span><br>
                            <span class="pl-2">{{hija.titulo_varios_registros}}</span><br>
                            <strong class="pl-2 text-break" [class]="hija.backgroundColor">{{hija.respuesta}}</strong>
                          </ng-container>
                          <!-- Respuestas varchar, date, numeric -->
                          <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Texto ||
                          hija.desc_tipo_dato === TipoCampoAdicional.Numerico ||
                          hija.desc_tipo_dato === TipoCampoAdicional.Fecha ||
                          hija.desc_tipo_dato === TipoCampoAdicional.TextArea">
                            <span>{{hija.titulo}}</span><br>
                            <strong [class]="hija.backgroundColor">{{hija.respuesta}}</strong>
                          </ng-container>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <!-- No data found -->
          <ng-template #sindatos_camposVA>
            <p class="small">Sin informacion registrada</p>
          </ng-template>
        </div>
      </div>

      <!-- Documentos -->
      <div class="card mt-4">
        <h5 class="card-header">Cumplimiento de requisitos</h5>
        <div class="card-body">
          <div *ngIf="arrayDocumento != null && arrayDocumento.length > 0 ; else sindatos_camposDocVA">
            <app-tablas [headers]="headersDocumentos" class="table-responsive overflow" [paginar]="false">
              <tr *ngFor="let item of arrayDocumento">
                <!-- MULTIPLE -->
                <ng-container *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Multiple; else containerUnicaVA">
                  <td colspan="2">
                    <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Multiple">
                      <div>
                        <ul class="list-unstyled">
                          <li *ngFor="let hija of item.hijasMultiple; index as i">
                            <!-- Sin son respuestas multiple -->
                            <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Multiple">
                              <div [ngClass]="{'pl-2' : i > 0}">
                                <span>{{hija.titulo}}</span><br>
                                <strong [class]="hija.backgroundColor">{{hija.respuesta}}</strong>
                              </div>
                            </ng-container>
                            <!-- Sin son respuestas multiple caracteristica -->
                            <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                              <div *ngFor="let caracteristica of hija.caracteristicas_Opciones">
                                <span [ngClass]="{'pl-2' : i > 0}">{{caracteristica.descripcion}}</span><br>
                                <strong [class]="caracteristica.backgroundColor" [ngClass]="{'pl-2' : i > 0}">{{caracteristica.Valor_Registros}}</strong>
                              </div>
                            </ng-container>
                            <!-- Sin son respuestas Boolean -->
                            <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Booleano">
                              <span [ngClass]="{'pl-2' : i > 0}">{{hija.titulo}}</span><br>
                              <strong [ngClass]="{'pl-2' : i > 0}" [class]="hija.backgroundColor" *ngIf="hija.respuesta === '1'">Si</strong>
                              <strong [ngClass]="{'pl-2' : i > 0}" [class]="hija.backgroundColor" *ngIf="hija.respuesta === '0'">No</strong>
                            </ng-container>
                            <!-- Sin son respuestas Varios registros -->
                            <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                              <span [class]="hija.backgroundColor" [ngClass]="{'pl-2' : i > 0}">{{hija.titulo}}</span><br>
                              <strong [class]="hija.backgroundColor" [ngClass]="{'pl-2' : i > 0}">{{hija.respuesta}}</strong>
                            </ng-container>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                  <td>
                    {{item.numero_certificado}}
                  </td>
                </ng-container>

                <ng-template #containerUnicaVA>
                  <td>
                    <span>{{item.titulo}}</span>
                  </td>
                  <td>
                    <!-- BIT -->
                    <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Booleano">
                      <strong *ngIf="item.respuesta === '1'" [class]="item.backgroundColor">Si</strong>
                      <strong *ngIf="item.respuesta === '0'" [class]="item.backgroundColor">No</strong>
                    </div>
                    <!-- BIGINT, VARCHAR -->
                    <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Texto || item.desc_tipo_dato === TipoCampoAdicional.Numerico">
                      <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                    </div>
                    <!-- TEXT_AREA -->
                    <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.TextArea">
                      <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                    </div>
                    <!-- DATETIME -->
                    <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Fecha">
                      <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                    </div>
                    <!-- MULTIPLE_CARACTERISTICA -->
                    <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                      <div *ngFor="let caracteristica of item.multipleCaracterisitca">
                        <ng-container *ngIf="caracteristica.caracteristicas_opciones_descripcion !== 'Lista desplegable'">
                          <span class="pl-2">{{caracteristica.descripcion}}</span><br>
                          <strong class="pl-2" [class]="caracteristica.backgroundColor">
                            {{caracteristica.Valor_Registros}}
                          </strong>
                        </ng-container>
                      </div>
                    </div>
                    <!-- VARIOS_REGISTROS -->
                    <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                      <span class="pl-2">{{item.titulo_varios_registros}}</span><br>
                      <strong class="pl-2 text-break" [class]="item.backgroundColor">{{item.respuesta}}</strong>
                    </div>
                  </td>
                </ng-template>

                <td>
                  {{item.numero_certificado}}
                </td>
              </tr>
            </app-tablas>
          </div>

          <!-- No data found -->
          <ng-template #sindatos_camposDocVA>
            <p class="small">Sin informacion registrada</p>
          </ng-template>
        </div>
      </div>
    </section>

    <!-- Version Anterior -->
    <section class="col-sm-12 col-md-6 mb-4 mt-4">
      <h2 class="col-12 h5 font-weight-bold mb-2 border-anterior">Versión anterior</h2>
      <section class="col-sm-12 col-md-12 mb-4 mt-4 opacity">
        <!-- Campo Adicional -->
        <div class="card mt-4">
          <h5 class="card-header">Campos adicionales</h5>

          <div class="card-body">
            <div class="row" *ngIf="arrayCampoAdicionalAnterior != null && arrayCampoAdicionalAnterior.length > 0 ; else sindatos_camposVAnca">
              <ul class="list-unstyled">
                <li class="mb-2" *ngFor="let item of arrayCampoAdicionalAnterior">
                  <!-- BIT -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Booleano">
                    <span>{{item.titulo}}</span><br>
                    
                    <strong *ngIf="item.respuesta === '1' && !item.turismoAventura" [class]="item.backgroundColor">Si</strong>
                    <strong *ngIf="item.respuesta === '0' && !item.turismoAventura" [class]="item.backgroundColor">No</strong>
                    
                    <strong *ngIf="item.turismoAventura?.length > 0 && item.turismoAventura" [class]="item.backgroundColor">Si</strong>
                    <strong *ngIf="item.turismoAventura?.length <= 0 && item.turismoAventura" [class]="item.backgroundColor">No</strong>

                    <!-- Turismo aventura -->
                    <ng-container *ngIf="item.turismoAventura">
                      <ul>
                        <li *ngFor="let itemAventura of item.turismoAventura" [class]="itemAventura.backgroundColor">
                          {{itemAventura.descripcion}}
                        </li>
                      </ul>
                    </ng-container>
                    <!-- Vehiculos-->
                    <div *ngIf="item.vehiculos;">
                      <div class="col-sm-12 col-md-12 mt-1" *ngIf="item.vehiculos">
                        <h2 class="h6 mt-2 mb-2">Vehículos registrados</h2>
                        <ul class="list-group">
                          <app-tablas [headers]="headersVehiculos" class="table-responsive overflow" [paginar]="false">
                            <tr *ngFor="let item of item.vehiculos" class="small">
                              <td>{{item.marca}}</td>
                              <td>{{item.linea}}</td>
                              <td>{{item.placa}}</td>
                              <td>{{item.color}}</td>
                            </tr>
                          </app-tablas>
                        </ul>
                      </div>

                      <ng-template *ngIf="item.vehiculos.length === 0">
                        <span style="font-style: italic; margin-left: 10px; font-weight: bold">No se encontraron vehículos relacionados.</span>
                      </ng-template>
                    </div>
                  </div>
                  <!-- BIGINT, VARCHAR -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Texto || item.desc_tipo_dato === TipoCampoAdicional.Numerico">
                    <span>{{item.titulo}}</span><br>
                    <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                  </div>
                  <!-- TEXT_AREA -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.TextArea">
                    <span>{{item.titulo}}</span><br>
                    <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                  </div>
                  <!-- DATETIME -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Fecha">
                    <span>{{item.titulo}}</span><br>
                    <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                  </div>
                  <!-- MULTIPLE_CARACTERISTICA -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                    <span>{{item.titulo}}</span><br>
                    <div *ngFor="let caracteristica of item.multipleCaracterisitca">
                      <ng-container *ngIf="caracteristica.caracteristicas_opciones_descripcion !== 'Lista desplegable'">
                        <span class="pl-2">{{caracteristica.descripcion}}</span><br>
                        <strong class="pl-2" [class]="caracteristica.backgroundColor">
                          {{caracteristica.Valor_Registros}}
                        </strong>
                      </ng-container>
                    </div>
                  </div>
                  <!-- VARIOS_REGISTROS -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                    <span>{{item.titulo}}</span><br>
                    <span class="pl-2">{{item.titulo_varios_registros}}</span><br>
                    <strong class="pl-2 text-break" [class]="item.backgroundColor">{{item.respuesta}}</strong>
                  </div>
                  <!-- MULTIPLE -->
                  <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Multiple">
                    <div>
                      <ul class="list-unstyled">
                        <li *ngFor="let hija of item.hijasMultiple; index as i">
                          <div [ngClass]=" i > 0 ? 'pl-2' : ''">
                            <!-- Respuestas multiple -->
                            <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Multiple">
                              <span>{{hija.titulo}}</span><br>
                              <strong [class]="hija.backgroundColor">{{hija.respuesta}}</strong>
                            </ng-container>
                            <!-- Respuestas multiple caracteristica -->
                            <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                              <div *ngFor="let caracteristica of hija.caracteristicas_Opciones">
                                <span>{{caracteristica.descripcion}}</span><br>
                                <strong [class]="caracteristica.backgroundColor">{{caracteristica.Valor_Registros}}</strong>
                              </div>
                            </ng-container>
                            <!-- Respuestas Bit -->
                            <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Booleano">
                              <span>{{hija.titulo}}</span><br>
                              <strong *ngIf="hija.respuesta === '1'" [class]="hija.backgroundColor">Si</strong>
                              <strong *ngIf="hija.respuesta === '0'" [class]="hija.backgroundColor">No</strong>
                            </ng-container>
                            <!-- Respuestas Varios registros -->
                            <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                              <span>{{hija.titulo}}</span><br>
                              <span class="pl-2">{{hija.titulo_varios_registros}}</span><br>
                              <strong class="pl-2 text-break" [class]="hija.backgroundColor">{{hija.respuesta}}</strong>
                            </ng-container>
                            <!-- Respuestas varchar, date, numeric -->
                            <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Texto ||
                              hija.desc_tipo_dato === TipoCampoAdicional.Numerico ||
                              hija.desc_tipo_dato === TipoCampoAdicional.Fecha ||
                              hija.desc_tipo_dato === TipoCampoAdicional.TextArea">
                              <span>{{hija.titulo}}</span><br>
                              <strong [class]="hija.backgroundColor">{{hija.respuesta}}</strong>
                            </ng-container>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <!-- No data found -->
            <ng-template #sindatos_camposVAnca>
              <p class="small">Sin informacion registrada</p>
            </ng-template>
          </div>
        </div>

        <!-- Documentos -->
        <div class="card mt-4">
          <h5 class="card-header">Cumplimiento de requisitos</h5>
          <div class="card-body">
            <div *ngIf="documentos!= null && arrayDocumentoAnterior.length > 0 ; else sindatos_camposDocVAdoc">
              <app-tablas [headers]="headersDocumentos" class="table-responsive overflow" [paginar]="false">
                <tr *ngFor="let item of arrayDocumentoAnterior">
                  <ng-container *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Multiple; else containerUnicaVAnt">
                    <td colspan="2">
                      <!-- MULTIPLE -->
                      <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Multiple">
                        <div>
                          <ul class="list-unstyled">
                            <li *ngFor="let hija of item.hijasMultiple; index as i">
                              <!-- Sin son respuestas multiple -->
                              <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Multiple">
                                <div [ngClass]="{'pl-2' : i > 0}">
                                  <span>{{hija.titulo}}</span><br>
                                <strong [class]="hija.backgroundColor">{{hija.respuesta}}</strong>
                                </div>
                              </ng-container>
                              <!-- Sin son respuestas multiple caracteristica -->
                              <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                                <div *ngFor="let caracteristica of hija.caracteristicas_Opciones">
                                  <span [ngClass]="{'pl-2' : i > 0}">{{caracteristica.descripcion}}</span><br>
                                  <strong [class]="caracteristica.backgroundColor" [ngClass]="{'pl-2' : i > 0}">{{caracteristica.Valor_Registros}}</strong>
                                </div>
                              </ng-container>
                              <!-- Sin son respuestas boolean -->
                              <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.Booleano">
                                <span [ngClass]="{'pl-2' : i > 0}">{{hija.titulo}}</span><br>
                                <strong [class]="hija.backgroundColor" [ngClass]="{'pl-2' : i > 0}" *ngIf="hija.respuesta === '1'">Si</strong>
                                <strong [class]="hija.backgroundColor" [ngClass]="{'pl-2' : i > 0}" *ngIf="hija.respuesta === '0'">No</strong>
                              </ng-container>
                              <!-- Sin son respuestas Varios registros -->
                              <ng-container *ngIf="hija.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                                <span [ngClass]="{'pl-2' : i > 0}">{{hija.titulo}}</span><br>
                                <strong [class]="hija.backgroundColor" [ngClass]="{'pl-2' : i > 0}">{{hija.respuesta}}</strong>
                              </ng-container>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <ng-template #containerUnicaVAnt>
                    <td>
                      <span>{{item.titulo}}</span>
                    </td>
                    <td>
                      <!-- BIT -->
                      <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Booleano">
                        <strong *ngIf="item.respuesta === '1'" [class]="item.backgroundColor">Si</strong>
                        <strong *ngIf="item.respuesta === '0'" [class]="item.backgroundColor">No</strong>
                      </div>
                      <!-- BIGINT, VARCHAR -->
                      <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Texto || item.desc_tipo_dato === TipoCampoAdicional.Numerico">
                        <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                      </div>
                      <!-- TEXT_AREA -->
                      <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.TextArea">
                        <strong [class]="item.backgroundColor">{{item.respuesta}}</strong>
                      </div>
                      <!-- DATETIME -->
                      <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.Fecha">
                        <strong [class]="item.backgroundColor">{{item.respuesta }}</strong>
                      </div>
                      <!-- MULTIPLE_CARACTERISTICA -->
                      <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.MultipleCaracteristica">
                        <div *ngFor="let caracteristica of item.multipleCaracterisitca">
                          <ng-container *ngIf="caracteristica.caracteristicas_opciones_descripcion !== 'Lista desplegable'">
                            <span class="pl-2">{{caracteristica.descripcion}}</span><br>
                            <strong class="pl-2" [class]="caracteristica.backgroundColor">
                              {{caracteristica.Valor_Registros}}
                            </strong>
                          </ng-container>
                        </div>
                      </div>
                      <!-- VARIOS_REGISTROS -->
                      <div *ngIf="item.desc_tipo_dato === TipoCampoAdicional.VariosRegistros">
                        <span class="pl-2">{{item.titulo_varios_registros}}</span><br>
                        <strong class="pl-2 text-break" [class]="item.backgroundColor">{{item.respuesta}}</strong>
                      </div>
                    </td>
                  </ng-template>
                  <td>{{item.numero_certificado}}</td>
                </tr>
              </app-tablas>
            </div>

            <!-- No data found -->
            <ng-template #sindatos_camposDocVAdoc>
              <p class="small">Sin informacion registrada</p>
            </ng-template>
          </div>
        </div>
      </section>
    </section>
  </section>
</ng-template>
